import { render, staticRenderFns } from "./ConfigurazioneDeviceDeviceListPage.vue?vue&type=template&id=5443d4c0&scoped=true"
import script from "./ConfigurazioneDeviceDeviceListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneDeviceDeviceListPage.vue?vue&type=script&lang=js"
import style0 from "./ConfigurazioneDeviceDeviceListPage.vue?vue&type=style&index=0&id=5443d4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5443d4c0",
  null
  
)

export default component.exports